<template>
  <div class="w-full">
    <label
      v-if="label"
      class="text-base text-primary font-inter font-medium block mb-1 leading-5"
      >{{ label }}</label
    >
    <div class="w-full relative">
      <!-- <div v-if="label === 'Mobile Number'" class="absolute top-0 left-0 h-14 flex items-center w-[107px]">
        <span @click="onCountryCode" class="flex items-center gap-1 py-1.5 pl-4 pr-3 text-base font-inter font-normal text-[#191817] border-r border-[#CACACE] w-full">
          <img :src="selectedCode?.flag" alt="" class="w-4">
          {{selectedCode?.code}}
          <svg class="ml-auto" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 7.5L10 12.5L15 7.5" stroke="#55555E" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <div v-if="showCountryCode" class="absolute top-full left-0 w-full bg-white border border-[#CACACE] flex flex-col z-[99]">
          <span v-for="(item, index) in countryCode" :key="index" @click="onSelectCountry(item)" class="flex items-center gap-1 py-1.5 pl-4 pr-3 text-base font-inter font-normal text-[#191817] border-b border-[#CACACE]" :class="{'bg-[#CACACE]': selectedCode?.code === item.code}">
            <img :src="item.flag" alt="" class="w-4">
            {{item.code}}
          </span>
        </div>
      </div> -->
      <!-- !border-l !border-l-[#CACACE] -->
      <div
        v-if="isPhone"
        class="absolute top-0 left-0 h-14 flex items-center w-[90px] border-r border-r-[#CACACE]"
        :class="{ '!border-[#CC1100]': showError }"
      >
        <vue-tel-input
          class="h-full border-0 bg-transparent"
          ref="phoneNumber"
          :dropdown-options="{
            showDialCodeInList: true,
            showDialCodeInSelection: true,
            showFlags: true,
            showSearchBox: true,
          }"
          :default-country="mapCountryCode"
          :autoDefaultCountry="false"
          type="tel"
          :preferred-countries="['SG']"
          @open="storeCountryCode"
          @country-changed="onSelectCountry($event)"
        />
      </div>
      <input
        v-if="type !== 'date'"
        :placeholder="placeholder"
        :type="type"
        v-model="inputValue"
        @change="handleValue"
        @focus="handleFocus"
        @blur="inBlur"
        :maxlength="isPhone ? 10 : textLimit"
        :disabled="disabled"
        class="h-14 border border-[#C3C2C1] bg-[#ffffff] rounded-[8px] px-[16px] text-[1rem] leading-[1.5rem] w-full font-inter font-normal text-[#191817] placeholder-[#373E49] focus:border-[#454BEF] focus:bg-white focus:ring-0 focus:outline-none hover:ring-0 hover:outline-none"
        :class="{
          '!bg-[#ECEBEB] border-[#ECEBEB]': disabled,
          'border-[#CC1100]': showError,
          'pl-[102px]': isPhone,
        }"
      />
      <template v-if="type === 'date'">
        <input
          ref="dateInput"
          type="text"
          placeholder="DD-MM-YYYY"
          :disabled="disabled"
          class="h-14 border border-[#C3C2C1] bg-[#ffffff] rounded-[8px] px-[16px] text-[1rem] leading-[1.5rem] w-full font-inter font-normal text-[#191817] placeholder-[#373E49] focus:border-[#454BEF] focus:bg-white focus:ring-0 focus:outline-none hover:ring-0 hover:outline-none"
          :class="{
            '!bg-[#ECEBEB] border-[#ECEBEB] !cursor-default': disabled,
            'border-[#CC1100]': showError,
            'pl-[119px]': isPhone,
          }"
        />
        <label
          class="w-[24px] h-[24px] absolute top-[14px] right-[6px] bottom-[6px] flex items-center"
          :class="{ 'cursor-pointer': !disabled }"
          @click="openDatePicker"
        >
          <img src="/assets/icons/calendar.svg" />
        </label>
      </template>
      <template v-if="isVerify">
        <span
          @click="verifyClick"
          class="absolute top-[6px] right-[6px] bottom-[6px] bg-[#FEC629] rounded-[8px] px-[16px] text-sm font-inter font-semibold flex items-center text-[#21201E]"
          v-if="verifyNumber && !showError && !hideVerifyWhenUnchanged"
          >Verify</span
        >
      </template>
    </div>
    <small
      class="pt-[4px] text-base italic block font-inter font-normal text-[#CC1100]"
      v-if="showError"
      >{{ inputValue === '' ? 'required' : errorMsg }}</small
    >
    <template v-else>
      <small
        class="pt-[4px] text-base italic block font-inter font-normal text-[#7A7A85]"
        v-if="helperText"
        >{{ helperText }}</small
      >
    </template>
  </div>
</template>
<style scoped>
input::before {
  display: none;
}

::v-deep input[type='date']::-webkit-date-and-time-value {
  text-align: left !important;
}
</style>
<script>
import allCountries from '@/constants/all-countries';
import { Capacitor } from '@capacitor/core';
import { Device } from '@capacitor/device';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';

export default {
  props: {
    modelValue: {
      type: String,
      default: '',
    },
    countryValue: {
      type: String,
      default: '',
    },
    // Shows the country code picker and limits the number to 10 digits.
    // An explicit prop, not a label check: a copy change to the label once turned the picker off.
    isPhone: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: true,
    },
    placeholder: {
      type: String,
      default: true,
    },
    textLimit: {
      type: Number,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    helperText: {
      type: String,
      default: false,
    },
    verifyClick: {
      type: Function,
      default: () => {},
    },
    errorMsg: {
      type: String,
      default: false,
    },
    isVerify: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    hideVerifyWhenUnchanged: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  emits: ['hideFooter', 'focus'],
  mounted() {
    Device.getInfo().then(info => {
      this.info = info;
    });

    // Initialize Flatpickr for date inputs
    if (this.type === 'date') {
      this.$nextTick(() => {
        this.initFlatpickr();
      });
    }
  },
  beforeUnmount() {
    // Clean up Flatpickr instance
    if (this.flatpickrInstance) {
      this.flatpickrInstance.destroy();
    }
  },
  data() {
    return {
      verifyNumber: false,
      countryCode: [
        { flag: '/assets/images/flag-icn.png', code: '+65' },
        { flag: '/assets/images/flag-icn.png', code: '+91' },
        { flag: '/assets/images/flag-icn.png', code: '+01' },
      ],
      openDropdown: false,
      platform: Capacitor.getPlatform(),
      info: undefined,
      showCountryCode: false,
      oldCode: this.countryValue.valueOf(),
      flatpickrInstance: null,
    };
  },
  computed: {
    inputValue: {
      get() {
        return this.modelValue; // Get value from parent
      },
      set(value) {
        this.$emit('update:modelValue', value); // Emit updated value to parent
      },
    },
    country: {
      get() {
        return this.countryValue; // Get value from parent
      },
      set(value) {
        this.$emit('update:countryValue', value); // Emit updated value to parent
      },
    },
    mapCountryCode() {
      return this.findCountryCode(this.countryValue);
    },
    isValidEmail() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.modelValue);
    },
  },
  methods: {
    handleValue(e) {
      if (e.target.value) {
        this.verifyNumber = true;
      } else {
        this.verifyNumber = false;
      }
    },
    findCountryCode(countryValue) {
      const country = allCountries.find(
        country =>
          country.dialCode == countryValue ||
          '+' + country.dialCode == countryValue ||
          '+' + countryValue == country.dialCode,
      );
      return country?.iso2;
    },
    storeCountryCode() {
      this.openDropdown = true;
      this.oldCode = this.countryValue.valueOf();
    },
    onSelectCountry(item) {
      if (this.oldCode != item.dialCode && this.openDropdown) {
        this.verifyNumber = true;
        this.$emit('update:countryValue', item.dialCode);
      }
    },
    initFlatpickr() {
      if (!this.$refs.dateInput) return;

      this.flatpickrInstance = flatpickr(this.$refs.dateInput, {
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd-m-Y',
        allowInput: false,
        clickOpens: true,
        disableMobile: false,
        onChange: (_selectedDates, dateStr) => {
          // Update the v-model with the selected date in YYYY-MM-DD format
          this.$emit('update:modelValue', dateStr);
        },
        defaultDate: this.modelValue || null,
        onReady: (_selectedDates, _dateStr, instance) => {
          // Apply custom classes to the alternate input
          if (instance.altInput) {
            instance.altInput.className = this.$refs.dateInput.className;
            instance.altInput.disabled = this.disabled;
          }
        },
      });
    },
    openDatePicker() {
      if (!this.disabled && this.flatpickrInstance) {
        this.flatpickrInstance.open();
      }
    },
    inFocus() {
      if (this.platform === 'web') {
        if (
          this.info &&
          (this.info?.operatingSystem === 'android' || this.info?.operatingSystem === 'ios')
        ) {
          this.$emit('hideFooter', true);
        }
      }
      this.$emit('focus', event);
    },
    inBlur() {
      console.log('blur');
      if (this.platform === 'web') {
        if (
          this.info &&
          (this.info?.operatingSystem === 'android' || this.info?.operatingSystem === 'ios')
        ) {
          this.$emit('hideFooter', false);
        }
      }
    },
  },
  watch: {
    countryValue(newVal) {
      // Only update phoneNumber ref if this is a phone field and ref exists
      if (this.isPhone && this.$refs.phoneNumber) {
        const countryCode = this.findCountryCode(newVal);
        if (countryCode && typeof this.$refs.phoneNumber.choose === 'function') {
          this.$refs.phoneNumber.choose(countryCode);
        }
      }
    },
    modelValue(newVal) {
      // Update Flatpickr when the modelValue changes from parent
      if (this.type === 'date' && this.flatpickrInstance) {
        this.flatpickrInstance.setDate(newVal || null, false);
      }
    },
    disabled(newVal) {
      // Update Flatpickr input disabled state when prop changes
      if (this.type === 'date' && this.$refs.dateInput) {
        this.$refs.dateInput.disabled = newVal;
        // Wait for Vue to update the DOM and re-evaluate :class bindings
        this.$nextTick(() => {
          // Also update the Flatpickr's alternate input if it exists
          if (this.flatpickrInstance?.altInput) {
            this.flatpickrInstance.altInput.disabled = newVal;
            // Update classes to reflect disabled state change
            this.flatpickrInstance.altInput.className = this.$refs.dateInput.className;
          }
        });
      }
    },
    showError() {
      // Update Flatpickr alternate input classes when error state changes
      if (this.type === 'date' && this.flatpickrInstance?.altInput && this.$refs.dateInput) {
        this.flatpickrInstance.altInput.className = this.$refs.dateInput.className;
      }
    },
  },
};
</script>
<style scoped>
::v-deep(.vue-tel-input input) {
  display: none;
}
</style>
